<template>
  <div class="main-chapter1">
    <div class="chapter-title">
      Форма 3. Второй лист журнала авторского надзора<br />
      Состав группы авторского надзора
    </div>
    <n-table :columns="columns" :data="data" :loading="$var('load')">
    </n-table>
  </div>
</template>

<script>
export default {
  name: 'MainChapter3',
  props: [ 'project', 'journal', ],
  data: () => ({
    columns: [
      { name: 'fullName', title: 'Ф.И.О. (при его наличии)', },
      { name: 'position', title: 'Должность, место работы', },
      { name: 'work', title: 'Работа, по которой осуществляется авторский надзор', },
      { name: 'document', title: 'Дата и номер приказа о включении в состав группы авторского надзора', },
    ],
    data: [
      { fullName: 'Баймуратов Бауржан Ержанович', position: 'Авторский надзор', work: 'Весь проект', },
    ],
  }),
  created() {
    // this.load()
  },
  methods: {
    load() {
      // this.$var('load', true)
      // $api.iq.projects.getActs(this.project.id).then((response) => {
      //   this.data = response.data.content
      // }).finally(() => {
      //   this.$var('load', false)
      // })
    },
    openDocument(item) {
      this.$router.push({ query: { ...this.$route.query, document: item.id, }, })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
